module.exports = __webpack_public_path__ + "static/img/5.62b6966f.jpg";